import { render, staticRenderFns } from "./PorSituacao.vue?vue&type=template&id=6f1e0206&scoped=true&lang=pug&"
import script from "./PorSituacao.vue?vue&type=script&lang=js&"
export * from "./PorSituacao.vue?vue&type=script&lang=js&"
import style0 from "./PorSituacao.vue?vue&type=style&index=0&id=6f1e0206&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1e0206",
  null
  
)

export default component.exports